var $ = require("jquery");

(function () {
    var servicesList = '[data-services-list]';
    var servicesListToggler = '[data-services-list-toggler]';

    $(document).on('click', servicesListToggler, function (event) {
        event.preventDefault();

        if (!$(servicesList).hasClass('-open')) {
            $(servicesList).addClass('-open')
            event.preventDefault();
            return false;
        }

        $(servicesList).removeClass('-open');
    });
})();

window.toggleBodyFreeze = function (add) {
    if (add) {
        document.body.classList.add('-freeze');
    }
    else 
        document.body.classList.remove('-freeze');
}

window.errorReload = function () {
    location.reload();
}

window.toggleModalFreeze = function(add) {

    if (add)
        document.getElementById("BookingModalContainer").classList.add('-freeze');
    else
        document.getElementById("BookingModalContainer").classList.remove('-freeze');
}

window.removeOpenClass = function () {
    $('[data-services-list]').removeClass('-open');
}

window.scrollToError = function () {
    var $validationErrors = $('[aria-invalid="true"]');

    console.log($validationErrors.length);

    if ($validationErrors.length > 0) {
        $('#BookingModalContainer').animate({
            scrollTop: $validationErrors[0].offsetTop - 32
        }, 100);
    }
}